<template>
	<SectionCard title="Profitto" icon="mdi-chart-line" subtitle="vendite nette e costo attuale del catalogo" no-padding data-tour="profit">
		<template #actions>
			<v-text-field v-model="search" label="Cerca" dense outlined hide-details clearable prepend-inner-icon="mdi-magnify" class="fp-search" />
		</template>
		<v-tabs v-model="tab" class="px-3" background-color="transparent">
			<v-tab v-for="t in tabs" :key="t.value">{{ t.label }}</v-tab>
		</v-tabs>
		<div v-if="tabs[tab] && tabs[tab].value === 'variants' && !variants.length" class="pa-6 text-center grey--text">Il dettaglio per variante è disponibile con tutti i canali.</div>
		<v-data-table
			v-else
			:headers="headers"
			:items="rows"
			:search="search"
			:custom-filter="filtro"
			:items-per-page="25"
			:footer-props="{ 'items-per-page-options': [25, 50, 100] }"
			sort-by="netSales"
			sort-desc
			dense
			class="elevation-0"
			item-key="key"
		>
			<template v-slot:[`item.title`]="{ item }">
				<div class="fp-title">{{ item.title || item.key }}</div>
				<div v-if="item.sku" class="fp-muted">{{ item.sku }}</div>
			</template>
			<template v-slot:[`item.netSales`]="{ item }">{{ formatEurCents(item.netSales) }}</template>
			<template v-slot:[`item.cost`]="{ item }">{{ formatEurCents(item.cost) }}</template>
			<template v-slot:[`item.profit`]="{ item }">
				<span :class="{ 'red--text text--darken-1': item.profit < 0 }">{{ formatEurCents(item.profit) }}</span>
			</template>
			<template v-slot:[`item.marginPct`]="{ item }">{{ formatPct(item.marginPct) }}</template>
			<template v-slot:[`item.salesWithoutCost`]="{ item }">
				<span :class="{ 'orange--text text--darken-2': item.salesWithoutCost > 0 }">{{ formatEurCents(item.salesWithoutCost) }}</span>
			</template>
		</v-data-table>
	</SectionCard>
</template>

<script>
import SectionCard from '@/components/core/SectionCard.vue';
import { formatEurCents, formatPct } from './format';

export default {
	name: 'FinanceProfit',
	components: { SectionCard },
	props: {
		report: { type: Object, required: true },
	},
	data() {
		return {
			tab: 0,
			search: '',
			tabs: [
				{ value: 'products', label: 'Prodotti' },
				{ value: 'variants', label: 'Varianti' },
				{ value: 'channels', label: 'Canali e punti vendita' },
			],
		};
	},
	computed: {
		variants() {
			return (this.report.profit && this.report.profit.variants) || [];
		},
		rows() {
			const key = (this.tabs[this.tab] || this.tabs[0]).value;
			return (this.report.profit && this.report.profit[key]) || [];
		},
		headers() {
			const first = (this.tabs[this.tab] || {}).value === 'channels' ? 'Canale' : 'Prodotto';
			return [
				{ text: first, value: 'title' },
				{ text: 'Quantità', value: 'qty', align: 'end' },
				{ text: 'Vendite nette', value: 'netSales', align: 'end' },
				{ text: 'Costo', value: 'cost', align: 'end' },
				{ text: 'Profitto lordo', value: 'profit', align: 'end' },
				{ text: 'Margine', value: 'marginPct', align: 'end' },
				{ text: 'Vendite senza costo', value: 'salesWithoutCost', align: 'end' },
			];
		},
	},
	methods: {
		formatEurCents,
		formatPct,
		filtro(value, search, item) {
			const s = String(search || '').toLowerCase();
			return [item.title, item.sku].some(v =>
				String(v || '')
					.toLowerCase()
					.includes(s),
			);
		},
	},
};
</script>

<style scoped>
.fp-search {
	max-width: 260px;
}
.fp-title {
	max-width: 420px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.fp-muted {
	font-size: 12px;
	color: #5f6b7a;
}
</style>
